<template>
  <b-card-code
    title="Modifier une délégation logistique"
    aria-label="Formulaire de modification de délégation logistique"
    role="form"
  >
    <b-card-text>
      <span id="delegation-edit-form-desc">Modifiez les informations de la délégation. Les champs * sont obligatoires.</span>
    </b-card-text>
    <validation-observer ref="simpleRules">
      <b-form
        v-if="delegation"
        aria-labelledby="delegation-edit-form-desc"
      >
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Code géographique"
              label-for="delegation-edit-code"
            >
              <b-form-input
                id="delegation-edit-code"
                v-model="delegation.code"
                readonly
                plaintext
                class="form-control-plaintext"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Nom de la délégation *"
              label-for="delegation-edit-name"
            >
              <validation-provider
                #default="{ errors }"
                name="Nom de la délégation"
                rules="required"
              >
                <b-form-input
                  id="delegation-edit-name"
                  v-model="delegation.name"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Nom officiel de la délégation"
                  aria-required="true"
                />
                <small
                  id="delegation-edit-name-help"
                  class="form-text text-muted d-none"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Gouvernorat *"
              label-for="delegation-edit-gov"
            >
              <validation-provider
                #default="{ errors }"
                name="Gouvernorat"
                rules="required"
              >
                <v-select
                  id="delegation-edit-gov"
                  v-model="delegation.governorate"
                  :clearable="false"
                  placeholder="Choisir un gouvernorat"
                  label="name"
                  :options="governorates"
                  aria-required="true"
                />
                <small
                  id="delegation-edit-gov-help"
                  class="form-text text-muted d-none"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-checkbox
              v-model="delegation.is_active"
              name="check-button"
              switch
              aria-label="Activer ou désactiver la délégation logistique"
            >
              Activation logistique
            </b-form-checkbox>
          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :class="{ 'disabled-cursor': isLoading || !isDelegationValid }"
              :disabled="isLoading || !isDelegationValid"
              aria-label="Modifier la délégation logistique"
              @click.prevent="editDelegation"
            >
              Modifier
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BCardText,
} from 'bootstrap-vue'
import { required } from '@validations'
import axios from 'axios'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    vSelect,
    BButton,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      id: '',
      required,
      delegation: {
        name: '',
        governorate: { id: '' },
        is_active: false,
      },
      governorates: [],
      isLoading: false,
    }
  },
  computed: {
    isDelegationValid() {
      return (
        this.delegation.name !== ''
        && this.delegation.governorate
        && this.delegation.governorate.id !== ''
      )
    },
  },
  created() {
    this.id = this.$route.params.id
    this.getDelegation()
    this.getGovernorates()
  },
  methods: {
    async getGovernorates() {
      try {
        this.isLoading = true
        const { data } = await axios.get('/api/governorates/')
        this.governorates = data
        this.isLoading = false
      } catch (error) {
        this.showToast('danger', 'top-center', 'Network error: ')
      }
    },
    async getDelegation() {
      try {
        this.isLoading = true
        const { data } = await axios.get(`/api/delegations/detail/${this.id}`)
        this.delegation = data
        this.isLoading = false
      } catch (error) {
        this.showToast('danger', 'top-center', 'Network error: ')
      }
    },
    async editDelegation() {
      const success = await this.$refs.simpleRules.validate()
      if (success) {
        try {
          this.isLoading = true
          await axios.put(`/api/delegations/update/${this.id}/`, {
            name: this.delegation.name,
            governorate: this.delegation.governorate.id,
            is_active: this.delegation.is_active,
          })
          this.isLoading = false
          setTimeout(() => {
            this.showToast('success', 'top-center', 'Delegation modifié avec succés')
          }, 1000)
          this.$router.push('/delegations/')
        } catch (error) {
          setTimeout(() => {
            this.showToast('danger', 'top-center', error.toString())
          }, 1000)
        }
      } else {
        setTimeout(() => {
          this.showToast('danger', 'top-center', 'champ obligatoire ! vérifier votre donnée !')
        }, 1000)
      }
    },

    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
